<template>
    <div>

        <!-- Table -->

        <trax-ui-card-plain-header-with-actions :title="lang.polaris.training.registrations_management" :actions="card_actions" :bus="bus">
            <trax-training-group-registration-crud-table :bus="bus" :id="id" :endpoint="endpoint">
            </trax-training-group-registration-crud-table>
        </trax-ui-card-plain-header-with-actions>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <trax-training-group-registration-crud-form :bus="bus" :id="id+'-edit'" :toastr-id="id+'-toastr'" :endpoint="endpoint">
            </trax-training-group-registration-crud-form>
        </trax-ui-modal-default>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="this.lang.polaris.training.registration_deletion" :bus="bus">
            {{ lang.polaris.training.confirm_delete_registration_q }}
        </trax-ui-modal-confirm>
        
        <!-- Search modal -->

        <trax-ui-modal-default :id="id+'-search'" :bus="bus" :title="lang.polaris.form.advanced_search">
            <trax-training-group-registration-crud-search :id="id" :bus="bus"></trax-training-group-registration-crud-search>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>
    
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'trax-training-group-registration'}
        },
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+"polaris/api/front/registrations",
                card_actions: [
                    { icon: 'search', event: this.id+'-search-open' },
                    { icon: 'add_box', event: this.id+'-edit-create' }
                ],
                bus: new Vue()
            }
        },

        created: function() {
            this.bus.$on(this.id+'-delete-error', this.deleteError);
        },

        methods: {
        
            deleteError(error) {
                if (error.status == 409) window.location = './'+error.id+'/force-delete';
            }
        }
    }
</script>
